function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdfIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M11.2998 0.75H25.2998C25.389 0.75 25.475 0.785546 25.5381 0.848633L35.251 10.5625C35.314 10.6255 35.3496 10.7107 35.3496 10.7998V32C35.3496 33.7949 33.8945 35.25 32.0996 35.25H11.2998C9.50488 35.25 8.0498 33.7949 8.0498 32V4C8.0498 2.20507 9.50488 0.75 11.2998 0.75Z",
    stroke: "#D0D5DD",
    style: {
      stroke: "#D0D5DD",
      stroke: "color(display-p3 0.8144 0.8349 0.8656)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2998 0.450195V6.80019C25.2998 9.00933 27.0907 10.8002 29.2998 10.8002H35.6498",
    stroke: "#D0D5DD",
    style: {
      stroke: "#D0D5DD",
      stroke: "color(display-p3 0.8144 0.8349 0.8656)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.599609 17.4004C0.599609 16.2958 1.49504 15.4004 2.59961 15.4004H24.5996C25.7042 15.4004 26.5996 16.2958 26.5996 17.4004V29.4004C26.5996 30.505 25.7042 31.4004 24.5996 31.4004H2.59961C1.49504 31.4004 0.599609 30.505 0.599609 29.4004V17.4004Z",
    fill: "#D92D20",
    style: {
      fill: "#D92D20",
      fill: "color(display-p3 0.8526 0.1757 0.1274)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.43191 27.4004V20.1277H7.30123C7.85284 20.1277 8.32277 20.233 8.71103 20.4437C9.09928 20.652 9.39521 20.9421 9.59881 21.3137C9.80478 21.6831 9.90776 22.1092 9.90776 22.5922C9.90776 23.0751 9.80359 23.5012 9.59526 23.8706C9.38693 24.2399 9.08508 24.5275 8.68972 24.7335C8.29673 24.9395 7.82087 25.0424 7.26216 25.0424H5.43333V23.8102H7.01358C7.30951 23.8102 7.55336 23.7593 7.74512 23.6575C7.93925 23.5533 8.08366 23.4101 8.17836 23.2278C8.27542 23.0431 8.32395 22.8313 8.32395 22.5922C8.32395 22.3507 8.27542 22.14 8.17836 21.96C8.08366 21.7778 7.93925 21.6369 7.74512 21.5375C7.55099 21.4357 7.30478 21.3848 7.00648 21.3848H5.96955V27.4004H4.43191ZM13.4846 27.4004H10.9065V20.1277H13.5059C14.2375 20.1277 14.8672 20.2733 15.3952 20.5645C15.9231 20.8533 16.3291 21.2688 16.6132 21.8109C16.8997 22.353 17.0429 23.0017 17.0429 23.7569C17.0429 24.5145 16.8997 25.1655 16.6132 25.71C16.3291 26.2546 15.9207 26.6724 15.3881 26.9636C14.8577 27.2548 14.2233 27.4004 13.4846 27.4004ZM12.4442 26.0829H13.4207C13.8753 26.0829 14.2576 26.0024 14.5677 25.8414C14.8802 25.6781 15.1146 25.426 15.2709 25.085C15.4295 24.7418 15.5088 24.2991 15.5088 23.7569C15.5088 23.2195 15.4295 22.7804 15.2709 22.4395C15.1146 22.0985 14.8814 21.8476 14.5713 21.6866C14.2612 21.5256 13.8788 21.4451 13.4243 21.4451H12.4442V26.0829ZM18.1819 27.4004V20.1277H22.9972V21.3954H19.7195V23.1284H22.6776V24.3961H19.7195V27.4004H18.1819Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfIcon);
export default __webpack_public_path__ + "static/media/pdfIcon.739dd8e53a9a9847521bff87fd458898.svg";
export { ForwardRef as ReactComponent };